module.exports = __webpack_public_path__ + "media/images/ecalls/bitcoin_dolar_fundo-6eaeaa8eb21550557e93c8867d81615a.png";